<kendo-loader></kendo-loader>
